module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git1-3a53823308d455fb0e6a1181554a6490.svg";